/**
 * The files worth uploading out of what the browser's file or folder dialog
 * handed over: hidden files and anything under a hidden directory are
 * dropped (#6559 rounds 10 and 12). The relative path is the browser's own
 * slash-joined string, not one of ours, so splitting it is reading its
 * format rather than inventing one; it never becomes a path we send.
 */
export const visibleChosenFiles = (files: Iterable<File>): File[] =>
  Array.from(files).filter(
    (file) =>
      !file.name.startsWith(".") &&
      !file.webkitRelativePath
        .split("/")
        .some((segment) => segment.startsWith("."))
  );
